import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

import { useOrganizationStore } from "@store/organizationStore";
import { useUserStore } from "@store/userStore";

const llmModelsMap = {
  anthropic: "Anthropic - Claude",
  openai: "OpenAI - Chat GPT",
} as const;

const AIChip = () => {
  const organization = useOrganizationStore((state) => state.organization);
  const user = useUserStore();

  const modelUsed = (organization?.chatModel || "openai") as keyof typeof llmModelsMap;

  const model = llmModelsMap[modelUsed];

  let tooltipText = "AI model can be set in your Organization Settings tab.";

  if (!user.organizationId) {
    tooltipText =
      "AI Model is defaulted to ChatGPT Enterprise for individual accounts. Reach out to sales about upgrading to an Organization.";
  }

  return (
    <Tooltip title={tooltipText}>
      <Chip color="info" label={`Using ${model}`} size="small" sx={{ cursor: "help" }} variant="filled" />
    </Tooltip>
  );
};

export default AIChip;
